import gql from 'graphql-tag';

export const MUTATION_DELETE_EQUIPMENT_COUNTING_JOURNAL_LINE = gql`
  mutation deleteEquipmentCountingJournalLine($id: String!) {
    deleteEquipmentCountingJournalLine(id: $id) {
      id
      journalId
      equipmentId
      status
    }
  }
`;
